module.exports = __webpack_public_path__ + "img/Realisme_Naturalismen_Zola.b2543faa.jpg";